var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",on:{"click":_vm.clickfun}},[_c('el-button',{staticClass:"loadButton",attrs:{"type":"primary","loading":false,"color":"#fff","width":"1070px"}},[_vm._v(_vm._s(_vm.isGaonS?_vm.isEnglish?"Load more...":"加载更多...":"加载更多..."))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-286d99d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/loadButton.vue
// module id = null
// module chunks = 